<template>
  <div>
    <div class="card" :id="`id-${runner.id}`">
      <div class="card-header">
        Рюкзак: <strong>{{ runner.name }}</strong> (id:{{ runner.id }}) выдан:
        {{ printDate(runner.back_pack.created_at) }}
      </div>
      <div class="card-body">
        <table class="table table-hover">
          <thead>
          <tr>
            <th width="65%">Препарат</th>
            <th v-if="showBackPackOrders">Заявки</th>
            <th>Закрытые заявки</th>
            <th>Количество</th>
            <th>Остаток</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(record, index) in orderedPrepNames(runner.back_pack.items)"
            :key="index"
          >
            <td>
              {{ record.new_drug.title }} ({{ record.drug_id }})
              <span v-if="record.qty < 0">
                  Возврат ({{ Math.abs(record.qty) }})</span
              >
              <div class="pack_details" v-if="record.new_drug.cool">
                <i class="icon icon-snowflake"/> Требуется хладоген
              </div>
              <div class="pack_details" v-if="record.new_drug.pack_comment">
                {{ record.new_drug.pack_comment }}
              </div>
              <div
                class="store_details text-muted"
                v-if="record.new_drug.pack_box_comment"
              >
                {{ record.new_drug.pack_box_comment }}
              </div>
              <div v-if="record.orders && record.orders.length" class="text-muted">
                <template v-for="order in record.orders">
                  <template
                    v-if="ordersData && ordersData[order] && ordersData[order].extra_options && ordersData[order].extra_options.comments_for_runner">
                    <p v-for="comment in ordersData[order].extra_options.comments_for_runner"
                       v-if="+comment.comment_type === 2">
                      <i class="icon-fa icon-fa-dropbox"></i> {{ comment.text }}
                    </p>
                  </template>
                </template>
              </div>
            </td>
            <td v-if="showBackPackOrders">
              <p v-for="order in record.orders">
                <strong>{{ mixinPrintOrderNum(order) }}</strong>
              </p>
            </td>
            <td>
              <template
                v-if="realisedDrugs && realisedDrugs[record.new_drug.id] && realisedDrugs[record.new_drug.id].orders.length">
                <p v-for="order in realisedDrugs[record.new_drug.id].orders" :key="order.id">
                  <strong>{{ mixinPrintOrderNum(order.id) }}</strong>: <span
                  class="text-muted fs-11">{{ order.report_date }}</span>
                </p>
              </template>
            <td>
              <template v-if="record.qty < 0">0</template>
              <template v-else>
                <template v-if="+record.new_drug.pack_set !== 1">
                  <p><strong>{{ record.qty / record.new_drug.pack_set }}</strong> компл.</p>
                  <p><strong>{{ record.qty }}</strong> зав.упак.</p>
                </template>
                <template v-else>
                  {{ record.qty }}
                </template>
              </template>
            </td>
            <td>
              <template v-if="+record.new_drug.pack_set !== 1">
                <p><strong>{{ getRemainingQty(record.qty, record.new_drug.id) / record.new_drug.pack_set }}</strong>
                  компл.(а/ов)</p>
                <p><strong>{{ getRemainingQty(record.qty, record.new_drug.id) }}</strong> зав.упак.</p>
              </template>
              <template v-else>
                {{ getRemainingQty(record.qty, record.new_drug.id) }}
              </template>
            </td>
          </tr>
          <tr v-for="(item) in getOverItems()" class="red">
            <td>
              {{ item.new_drug.title }} ({{ item.new_drug }})
              <div class="pack_details" v-if="item.new_drug.cool">
                <i class="icon icon-snowflake"/> Требуется хладоген
              </div>
              <div class="pack_details" v-if="item.new_drug.pack_comment">
                {{ item.new_drug.pack_comment }}
              </div>
              <div
                class="store_details text-muted"
                v-if="item.new_drug.pack_box_comment"
              >
                {{ item.new_drug.pack_box_comment }}
              </div>
            </td>
            <td v-if="showBackPackOrders"></td>
            <td>
              <p v-for="order in item.orders">
                <strong>{{ mixinPrintOrderNum(order.id) }}</strong>: <span class="text-muted fs-11">{{
                  order.report_date
                }}</span>
              </p>
            </td>
            <td>0</td>
            <td>-{{ item.qty }}</td>
          </tr>
          </tbody>
        </table>

        <div class="text-right" v-if="$currentRole != 'storeKeeper'">
          <button
            @click="openModal(runner)"
            type="button"
            class="btn btn-warning"
          >
            Обнулить рюкзак
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["runner", 'ordersData', "realisedDrugs", "openModal", 'showBackPackOrders'],
  data() {
    return {};
  },
  methods: {
    getOverItems() {
      if (!this.realisedDrugs) return [];
      const drugIdsInPack = this.runner.back_pack.items.reduce((acc, i) => {
        acc.push(i.drug_id);
        return acc;
      }, []);
      const overItems = Object.keys(this.realisedDrugs).reduce((acc, dId) => {
        if (!drugIdsInPack.includes(+dId)) {
          acc.push(this.realisedDrugs[dId]);
        }
        return acc;
      }, []);
      return overItems.reduce((acc, item) => {
        item.orders.forEach((o) => {
          o.details.forEach((d) => {
            acc.push({
              new_drug: d.new_drug,
              qty: item.qty,
              orders: item.orders.reduce((acc, oo) => {
                acc.push({
                  id: oo.id,
                  report_date: oo.report_date
                })
                return acc;
              }, [])
            });
          })
        })
        return acc;
      }, []);
    },
    getRemainingQty(num, drugId) {
      if (num < 0) {
        if (
          this.realisedDrugs === undefined ||
          this.realisedDrugs[drugId] === undefined
        )
          return 0;
        return this.realisedDrugs[drugId].qty;
      }
      if (this.realisedDrugs === undefined) return num;
      if (this.realisedDrugs[drugId] === undefined) return num;

      return num - this.realisedDrugs[drugId].qty;
    },
    orderedPrepNames: function (preps, request = false) {
      let sorted = _.orderBy(preps, "new_drug.title");
      if (request) {
        sorted = sorted.filter(x => request[x.id]);
      }
      return sorted;
    }
  }
};
</script>

<style scoped>
.red {
  background-color: #ffd8d8;
}

.fs-11 {
  font-size: 11px;
}

table th {
  white-space: normal;
}

table.table p {
  margin-bottom: 2px;
}

table.table td {
  padding: 2px;
}

.icon-snowflake {
  display: inline-block;
  vertical-align: -webkit-baseline-middle;
  width: 17px;
  height: 19px;
  background: #5bbfde;
  margin: 0 auto;
  mask: url(/assets/svg/snowflake-solid.svg);
}

@media only screen
and (max-width: 760px), (min-device-width: 768px)
and (max-device-width: 1024px) {
  .row {
    margin: 0;
  }

  .col-md-6,
  .col-md-12 {
    padding: 0;
  }

  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    /*margin: 0 0 1rem 0;*/
    border-bottom: 2px solid gray;
  }

  tr:nth-child(odd) {
    background: #f9f9f9;
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #d4d4d4;
    position: relative;
    padding-left: 30% !important;
    min-height: 35px;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 0;
    left: 6px;
    width: 27%;
    padding-right: 10px;
    white-space: normal;
    font-size: 12px;
  }

  /*
  Label the data
  You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
  */
  td:nth-of-type(1):before {
    content: "Препарат";
  }

  td:nth-of-type(2):before {
    content: "Заявки при выдаче";
  }

  td:nth-of-type(3):before {
    content: "Закрытые заявки";
  }

  td:nth-of-type(4):before {
    content: "Выдано";
  }

  td:nth-of-type(5):before {
    content: "Остаток";
  }

}
</style>

<style>
.pack_details {
  font-size: 12px;
  color: #3bb3d8;
}

.store_details {
  font-size: 12px;
}
</style>
